module.exports = __webpack_public_path__ + "img/right-indentation.4e244c5d.svg";